import styles from '../../../../../ApplicationMaintenance.module.scss';
import { ComponentDependency } from '../../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import { useEffect, useState } from 'react';
import Base from '../../../../../../Base/Base';
import Modal from '@mui/material/Modal';
import ApiErrors from '../../../../../components/NewApplication/ApiErrors';
import Section from '../../../../../components/NewApplication/Section';
import Spinner from '../../../../../../../components/UI/Spinner/Spinner';
import AppDataSelect from '../../AppDataManagement/components/AppDataSelect';
import ComponentSelect from '../../ComponentSelect';
import {
	CreateComponentDependency,
	UpdateComponentDependency,
} from '../../../../../_api';
import ComponentDependencyRequest from '../../../../../../../Classes/ResponseModels/ApplicationManagement/ComponentDependencyRequest';
const ComponentDependencyForm = ({
	componentDependency = new ComponentDependency(),
	component,
	app,
	currentUser,
	reload,
	readOnly,
	requirementNumber,
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [apiErrors, setApiErrors] = useState([]);
	const [validationErrors, setValidationErrors] = useState([]);
	const [localDependency, setLocalDependency] = useState({
		...componentDependency,
		componentID: componentDependency.componentID ?? component.id,
	});
	const isNew = componentDependency?.id == null;

	useEffect(() => {
		setValidationErrors(ComponentDependency.validate(localDependency));
	}, [localDependency]);

	const handleSave = () => {
		const request = new ComponentDependencyRequest(
			app,
			currentUser,
			localDependency
		);
		request.RequirementNumber = requirementNumber;
		//if is new, create new dependency record, else update existing record
		if (isNew) {
			setIsLoading(true);
			CreateComponentDependency(request).then(resp => {
				setIsLoading(false);
				//if error, display error, if not, reload the component

				if (resp.App.Errors.length > 0) {
					setApiErrors(resp.App.Errors);
				} else {
					reload();
				}
			});
		} else {
			setIsLoading(true);
			UpdateComponentDependency(request).then(resp => {
				setIsLoading(false);
				//if error, display error, if not, reload the component

				if (resp.App.Errors.length > 0) {
					setApiErrors(resp.App.Errors);
				} else {
					reload();
				}
			});
		}
	};

	const handleAppDataChange = e => {
		setLocalDependency({
			...localDependency,
			conditionalAppDataID: e.target.value,
			conditionalAppData: component.appData.find(
				x => x.id === e.target.value
			),
		});
	};

	const handleDependantComponentChange = e => {
		setLocalDependency({
			...localDependency,
			componentDependantID: e.target.value,
			componentDependant: app.components.find(
				x => x.id === e.target.value
			),
		});
	};
	return (
		<>
			<div>
				<div className={styles.controlsContainer}>
					<Button
						id='componentDependency_Form_modal_open'
						onClick={() => setModalOpen(true)}
						startIcon={
							isNew ? (
								<MaterialIcon icon='add' />
							) : (
								<MaterialIcon icon='edit' />
							)
						}
						disabled={readOnly}
					>
						{isNew ? 'Add Component Dependency' : 'Update'}
					</Button>
				</div>
				<Modal
					open={modalOpen}
					onClose={() => {
						setApiErrors([]);
						setModalOpen(false);
						setLocalDependency({ ...componentDependency });
					}}
				>
					<div className={styles.Modal}>
						<Base title='Component Dependency'>
							{isLoading ? (
								<Spinner />
							) : (
								<>
									<ApiErrors errors={apiErrors} />
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											startIcon={
												<MaterialIcon icon='save' />
											}
											id='compDependency_Save'
											disabled={
												readOnly ||
												validationErrors.length > 0
											}
										>
											Save
										</Button>
									</div>

									<Section label='Component Dependency'>
										<div className={styles.row}>
											<div className={styles.text_md}>
												When the{' '}
												<strong>
													{component.label}
												</strong>{' '}
												component value is{' '}
												<AppDataSelect
													options={component.appData}
													handleChange={e =>
														handleAppDataChange(e)
													}
													selected={
														localDependency.conditionalAppData
													}
													validationErrors={validationErrors.filter(
														err =>
															err.field ===
															'conditionalAppDataID'
													)}
												/>{' '}
												the{' '}
												<ComponentSelect
													options={app.components.filter(
														comp => comp.label !== component.label
													)}
													handleChange={e =>
														handleDependantComponentChange(
															e
														)
													}
													selected={
														localDependency.componentDependant
													}
													validationErrors={validationErrors.filter(
														err =>
															err.field ===
															'componentDependantID'
													)}
												/>{' '}
												component should be made visible
											</div>
										</div>
									</Section>
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											startIcon={
												<MaterialIcon icon='save' />
											}
											id='compDependency_Save2'
											disabled={
												readOnly ||
												validationErrors.length > 0
											}
										>
											Save
										</Button>
									</div>
								</>
							)}
						</Base>
					</div>
				</Modal>
			</div>
		</>
	);
};

export default ComponentDependencyForm;
